// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ChannelLogo-module__wrap___DJBDS","logo":"ChannelLogo-module__logo___71U9d","dot":"ChannelLogo-module__dot___34SVx"};